export const MFM_COMPARISON_NS = 'components/mfmComparison';

export const i18n = {
  en: {
    mfmDevices: 'MFM Devices',
    selectMfmDevices: 'Select the MFM devices for comparison and press Compare to see the results.',
    resetAll: 'Reset',
    compare: 'Compare',
    noDataMessage:
      'Select two or more MFM devices to compare data during the specified time range.',
  },
};
